import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import classNames from 'classnames/bind';
import React from 'react';
import IcTxtMainCategoryFinance from '../icons/IcTxtMainCategoryFinance.js';
import IcTxtMainCategoryMyAsset from '../icons/IcTxtMainCategoryMyAsset.js';
import IcTxtMainCategoryPay from '../icons/IcTxtMainCategoryPay.js';
import IcTxtMainCategoryRealEstate from '../icons/IcTxtMainCategoryRealEstate.js';
import IcTxtMainCategoryStock from '../icons/IcTxtMainCategoryStock.js';
import '../../constants/bottomNavigationBar.js';
import '../../constants/footer.js';
import '../../constants/footerQuickMenuItem.js';
import { NF_SERVICE_TYPE, NF_SERVICE_INFO } from '../../constants/global.js';
import { getServiceUrl } from '../../utils/index.js';
import styles from './HeaderName.module.scss.js';

var _excluded = ["serviceType", "size", "href"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var ICON_WIDTH = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, NF_SERVICE_TYPE.MY_ASSET, {
  small: 46,
  large: 60
}), NF_SERVICE_TYPE.PAYMENT, {
  small: 35,
  large: 35
}), NF_SERVICE_TYPE.FINANCE, {
  small: 28,
  large: 37
}), NF_SERVICE_TYPE.STOCK, {
  small: 28,
  large: 36
}), NF_SERVICE_TYPE.REAL_ESTATE, {
  small: 42,
  large: 56
});
var HEADER_TITLE = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, NF_SERVICE_TYPE.MY_ASSET, {
  icon: function icon(_ref) {
    var width = _ref.width;
    return /*#__PURE__*/React.createElement(IcTxtMainCategoryMyAsset, {
      width: width,
      height: 22
    });
  },
  text: NF_SERVICE_INFO[NF_SERVICE_TYPE.MY_ASSET].text
}), NF_SERVICE_TYPE.PAYMENT, {
  icon: function icon(_ref2) {
    var width = _ref2.width;
    return /*#__PURE__*/React.createElement(IcTxtMainCategoryPay, {
      width: width,
      height: 22
    });
  },
  text: NF_SERVICE_INFO[NF_SERVICE_TYPE.PAYMENT].text
}), NF_SERVICE_TYPE.FINANCE, {
  icon: function icon(_ref3) {
    var width = _ref3.width;
    return /*#__PURE__*/React.createElement(IcTxtMainCategoryFinance, {
      width: width,
      height: 22
    });
  },
  text: NF_SERVICE_INFO[NF_SERVICE_TYPE.FINANCE].text
}), NF_SERVICE_TYPE.STOCK, {
  icon: function icon(_ref4) {
    var width = _ref4.width;
    return /*#__PURE__*/React.createElement(IcTxtMainCategoryStock, {
      width: width,
      height: 22
    });
  },
  text: NF_SERVICE_INFO[NF_SERVICE_TYPE.STOCK].text
}), NF_SERVICE_TYPE.REAL_ESTATE, {
  icon: function icon(_ref5) {
    var width = _ref5.width;
    return /*#__PURE__*/React.createElement(IcTxtMainCategoryRealEstate, {
      width: width,
      height: 22
    });
  },
  text: NF_SERVICE_INFO[NF_SERVICE_TYPE.REAL_ESTATE].text
});
function HeaderName(_ref6) {
  var serviceType = _ref6.serviceType,
    size = _ref6.size,
    href = _ref6.href,
    props = _objectWithoutProperties(_ref6, _excluded);
  var _HEADER_TITLE$service = HEADER_TITLE[serviceType],
    Icon = _HEADER_TITLE$service.icon,
    text = _HEADER_TITLE$service.text;
  var width = ICON_WIDTH[serviceType][size];
  return (
    /*#__PURE__*/
    // [D] 해당 탭
    React.createElement("a", _objectSpread({
      href: href || getServiceUrl(serviceType),
      className: cx('article')
    }, props), /*#__PURE__*/React.createElement(Icon, {
      width: width
    }), /*#__PURE__*/React.createElement("span", {
      className: "blind"
    }, text))
  );
}

export { HeaderName as default };
